/** Price Reductions feed (v1 price-reductions.js). Newest-first table of every
 * price cut across leads; a row opens that lead. Read-only. */
import { useMemo } from "react";
import { buildDropFeed, fmtDropDate, fmtUsd } from "./api";
import type { Lead } from "../../types";

export function PriceReductionsPage({ leads, onOpenLead }: {
  leads: Lead[];
  onOpenLead: (address: string) => void;
}) {
  const feed = useMemo(() => buildDropFeed(leads), [leads]);
  const stats = useMemo(() => ({
    count: feed.length,
    properties: new Set(feed.map((f) => f.address)).size,
    totalDrop: feed.reduce((s, f) => s + f.drop, 0),
  }), [feed]);

  return (
    <div className="leads exppage">
      <div className="anlhero">
        <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
          <span style={{ width: 44, height: 44, flex: "none", borderRadius: 12, background: "#dc2626", display: "grid", placeItems: "center", fontSize: 20 }}>📉</span>
          <div className="anlherotext">
            <h1>Price Reductions</h1>
            <p>Every price drop across your leads, newest first — from a scraper re-check, an email, or a text.</p>
          </div>
        </div>
      </div>

      <div className="cstats" style={{ gridTemplateColumns: "repeat(3, 1fr)" }}>
        <div className="cstat blue"><strong>{stats.count}</strong><span>Total Reductions</span></div>
        <div className="cstat violet"><strong>{stats.properties}</strong><span>Properties Affected</span></div>
        <div className="cstat amber"><strong>{fmtUsd(stats.totalDrop)}</strong><span>Total Price Drop</span></div>
      </div>

      {feed.length === 0 ? (
        <div className="expempty">No price reductions yet. When a lead's price drops it shows up here.</div>
      ) : (
        <div className="explist">
          <table className="exptable">
            <thead>
              <tr>
                <th>Date</th><th>Property</th><th className="r">Was</th><th className="r">Now</th><th className="r">Drop</th><th>Source</th>
              </tr>
            </thead>
            <tbody>
              {feed.map((f, i) => (
                <tr key={i} className="click" onClick={() => onOpenLead(f.address)}>
                  <td className="dim">{fmtDropDate(f.date)}</td>
                  <td>
                    <div className="pdaddr">{f.address}</div>
                    {f.county ? <div className="pdsub">{f.county}</div> : null}
                  </td>
                  <td className="r dim" style={{ textDecoration: "line-through" }}>{fmtUsd(f.from)}</td>
                  <td className="r"><strong>{fmtUsd(f.to)}</strong></td>
                  <td className="r pddrop">{fmtUsd(f.drop)}{f.pct != null ? <span className="pdpct"> ({f.pct}%)</span> : null}</td>
                  <td className="dim">{f.source || (f.preCrm ? "pre-CRM" : "—")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
